import { render, staticRenderFns } from "./userIntegral.vue?vue&type=template&id=2ba19354&scoped=true"
import script from "./userIntegral.vue?vue&type=script&lang=js"
export * from "./userIntegral.vue?vue&type=script&lang=js"
import style0 from "./userIntegral.vue?vue&type=style&index=0&id=2ba19354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba19354",
  null
  
)

export default component.exports